<template>
  <div id="Switch">

    <Head />
    <div class="hotspot clear">
      <Nav ms="/Switch" />
      <div class="H-right">
        <div class="title1">成果申报管理</div>
        <div class="H-header">
          <div class="box">
            <span>成果申报状态：</span>
            <el-switch v-model="value1" @change="changeStatus"></el-switch>
            <span :style="value1 ? 'color:#409eff' : 'color:#303133'">{{ value1 ? "开启" : "关闭" }}</span>

          </div>
          <div class="box">
            <span>申报时间：</span>
            <el-date-picker v-model="time1" type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
            <el-button @click="submitTime" type="primary" style="margin-left: .1rem;">确定修改</el-button>
          </div>
          <span style="color:red">备注：设定的申报时间作为系统新一轮自动刷新的依据。系统已设置定时任务会根据设置时间自动开启或关闭申报入口。同时支持原先的手动控制。
          </span>

        </div>
        <div class="t_main">
          <el-table :data="tableData" border
            :header-cell-style="{ 'background-color': '#001743', 'color': '#fff', 'height': '0.5rem' }" :stripe="true"
            style="width: 100%;max-height:95%" :row-style="{ 'height': '0.4rem' }">
            <el-table-column label="序号" type="index" align="center" width="50"></el-table-column>
            <el-table-column label="操作日志" prop="message" align="center"></el-table-column>
            <el-table-column label="操作时间" prop="create_time" align="center"></el-table-column>
          </el-table>
          <el-pagination style="text-align: right;height: 0.45rem;" v-if="tableData.length > 0"
            @current-change="CurrentChange1" @size-change="handleSizeChange1" :current-page="Page1" :page-size="PageSize1"
            :page-sizes="[10, 20, 30]" layout="total,sizes, prev, pager, next, jumper" :total="total1"></el-pagination>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
export default {
  data() {
    return {
      value1: "",
      time1: "",
      time2: "",
      tableData: [],
      token: sessionStorage.getItem("token"),
      Page1: 1,
      PageSize1: 10,
      total1: 0,
    };
  },
  created() {
    this.value1 = this.$store.state.value1;
    // this.time1 = this.$store.state.timeRange;
    this.getSwitch()
  },
  mounted() {
    this.getList();
  },
  computed: {
    value2() {
      this.$store.dispatch("getStatus");
      return this.$store.state.value1;
    },
  },
  watch: {
    value2: function (val) {
      this.value1 = val;
    },
  },
  methods: {
    getSwitch() {
      this.$axios
        .post("log/systemStatus?token=" + sessionStorage.getItem("token"))
        .then((res) => {
          if (res.data.code == 10000) {
            this.time1 = [res.data.data.applyStart, res.data.data.applyEnd]
          }
        });
    },
    CurrentChange1(val) {
      this.Page1 = val;
      this.getList();
      //this.GetClass()
    },
    handleSizeChange1(val) {
      // console.log(val)
      this.PageSize1 = val;
      this.getList();
      //this.GetClass()
    },
    getList() {
      this.$axios
        .post(
          "systemlog/systemstatus",
          this.$qs.stringify({
            token: this.token,
            page: this.Page1,
            num: this.PageSize1,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.tableData = res.data.data.list;
            this.total1 = res.data.data.total_num;
          }
        });
    },
    changeStatus() {
      this.$axios
        .post(
          "log/systemStatus_edit",
          this.$qs.stringify({
            status: this.value1 ? "0" : "1",
            token: this.token,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    submitTime() {
      this.$axios
        .post(
          "log/systemDate_edit",
          this.$qs.stringify({
            token: this.token,
            start_date: this.time1 ? this.time1[0] : "",
            end_date: this.time1 ? this.time1[1] : "",
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.getList();
            this.$store.dispatch("getStatus");
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
  },
  components: {
    Head,
    Foot,
    Nav,
  },
};
</script>

<style lang="less" scoped>
.btns {
  display: flex;
  justify-content: center;
}

.time {
  position: relative;

  .time-select {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }
}

.clear:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.btn {
  width: 4.6rem;
  cursor: pointer;
  height: 0.58rem;
  line-height: 0.58rem;
  font-size: 0.17rem;
  text-align: center;
  background: #2d65d2;
  color: #fff;
}

.btnchange {
  background-color: #f2f2f4;
  color: #000000;
}

.btnmini {
  width: 1rem;
  height: 0.4rem;
  line-height: 0.4rem;
  border-radius: 0.05rem;
}

.hotspot {
  width: 100%;
  min-width: 1000px;
  font-size: 0.16rem;
  padding: 0.28rem 1rem 0 2.54rem;
  box-sizing: border-box;

  .H-right {
    position: relative;
    width: 13rem;
    min-width: 750px;
    padding-left: 0.2rem;
    height: 100%;
    float: right;
    min-height: 7.4rem;
    border-left: 1px #eeeeee solid;

    // .left-button {
    //   display: flex;
    //   .lastBtn {
    //     margin-left: 0.6rem;
    //   }
    // }
    .title1 {
      font-size: 0.4rem;
      margin: 0.2rem 0 0.5rem;
      text-align: center;
    }

    .btnselect {
      display: flex;
    }

    .H-header {
      display: flex;
      // align-items: center;
      flex-direction: column;
      margin-bottom: 0.2rem;

      .box {
        margin-bottom: .1rem;

        span {
          font-size: 0.18rem;
          font-weight: 700;
          margin-right: 0.2rem;
        }

        span {
          margin-left: 0.1rem;
          font-size: 0.18rem;
        }

      }

      .t-left {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.5rem;
        position: relative;

        .select {
          display: flex;
          width: 80%;
        }

        .btn1 {
          background: rgb(247, 100, 35);
          width: 1.5rem;
          height: 0.4rem;
          color: #fff;
          border-radius: 0.05rem;
          text-align: center;
          line-height: 0.4rem;
          display: flex;
          position: absolute;
          right: -0.1rem;
          cursor: pointer;
          top: 0.05rem;
          z-index: 10;
          justify-content: space-around;
          align-items: center;
          padding: 0 0.15rem;

          i {
            // margin: 0.07rem 0.2rem 0 0.2rem;
            width: 0.28rem;
            height: 0.28rem;
            background-image: url("../../assets/back/Excel.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            // background-size: 50%  100%;
          }
        }

        >span,
        select,
        div,
        input {
          margin-right: 0.2rem;
          width: 2rem;
          height: 0.4rem;
        }

        input {
          padding: 0.05rem;
        }
      }

      .t-right {
        float: right;
      }
    }

    .t_main {
      .table {
        .list {
          width: 100%;
          display: flex;
          padding-bottom: 0.2rem;
          align-items: center;
          position: relative;
          border-bottom: 1px #d9d9d9 solid;

          &:hover {
            background: #f0f0f0;
          }

          .btn {
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
          }

          .l-right {
            width: 3.14rem;
            height: 1.56rem;
            position: relative;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .l-info {
            flex: 1;
            // padding-left: 0.3rem;
            font-size: 0.16rem;
            color: #4e4e4e;
            height: 100%;

            .l-info-name {
              span {
                font-size: 0.2rem;
                font-weight: bold;
                color: #171717;
                line-height: 0.5rem;
              }

              i {
                font-style: normal;
                background: #ff0a0a;
                color: #ffffff;
                display: inline-block;
                font-size: 0.14rem;
                margin-left: 0.2rem;
                height: 0.19rem;
                text-align: center;
                border-radius: 0.04rem;
              }
            }

            .l-info-text {
              height: 0.5rem;
              margin-bottom: 0.1rem;
            }

            .l-info-time {
              margin-right: 0.2rem;
              margin-bottom: 0.1rem;
            }

            .l-info-text {
              span {
                float: left;
                font-weight: 800;
                margin-right: 0.2rem;
                line-height: 0.25rem;
              }

              div {
                margin-left: 0.4rem;
                line-height: 0.25rem;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
              }
            }
          }
        }
      }
    }

    // .l-main{
    //   .list{
    //     display: flex;
    //     // justify-content: space-around;
    //     align-items: center;
    //     border-bottom: 1px #d9d9d9 solid;
    //     padding: 0.2rem 0;
    //     .content{
    //       flex: 1;
    //       .content-name{
    //         margin-bottom: 0.15rem;
    //         span{
    //           font-size: .2rem;
    //           font-weight: bold;
    //           // line-height: 2.5;
    //         }
    //       }
    //       .content-group{
    //         margin: 0.1rem 0;
    //       }
    //     }
    //     .btn{
    //       align-self: start;
    //       // margin-top: 0.2rem;
    //     }
    //   }
    // }
    .info {
      padding: 0.3rem;
      border: 1px #d0d0d0 solid;
      margin-bottom: 0.3rem;

      >div {
        height: 0.7rem;
        display: flex;

        p {
          width: 2rem;
        }
      }

      .span1 {
        margin-left: 0.4rem;
      }

      .span2 {
        margin-left: 0.7rem;
      }

      .span3 {
        margin-left: 0.85rem;
      }

      span {
        display: inline-block;
        color: white;
        width: 1rem;
        text-align: center;
        line-height: 0.5rem;
        height: 0.5rem;
        cursor: pointer;
        background: #2d65d2;
        border-radius: 0.1rem;
      }

      // > div:nth-of-type(5) {
      //   display: flex;
      //   span {
      //     display: inline-block;
      //     width: 2.2rem;
      //   }
      //   div {
      //     margin: 0;
      //     margin-top: 0.1rem;
      //   }
      // }
      >div {

        // margin:0.5rem 0 ;
        // > div {
        //   margin-left: 0.9rem;
        //   line-height: 0.26rem;
        // }
        >span {
          // float: left;
          line-height: 0.5rem;
        }

        .upload {
          cursor: pointer;
          width: 10rem;
          padding-left: 0.5rem;
          background: url(../../assets/back/18.png) left center no-repeat;
        }
      }
    }

    .title {
      margin: 0.5rem 0;
      font-size: 0.18rem;
      font-family: Microsoft YaHei;

      >input {
        float: right;
        height: 0.35rem;
        margin-right: 50%;
        padding: 0.05rem;
      }

      >div {
        display: flex;
        height: 0.35rem;
        align-items: center;

        >div {
          height: 0.05rem;
          width: 0.05rem;
          border-radius: 50%;
          background: #2d65d2;
          margin-right: 0.2rem;
        }
      }
    }

    .jieguo {
      font-size: 0.18rem;
      font-weight: bold;
      margin: 0.5rem 0;
      display: flex;
      align-items: center;

      .repetition {
        width: 1.1rem;
        height: 0.4rem;
        background: #ff0000;
        border-radius: 0.05rem;
        color: #fff;
        text-align: center;
        line-height: 0.4rem;
      }

      .jieguospan {
        color: #1c1c1c;
        margin-left: 0.05rem;
      }

      // line-height: 100%;
      // height: .4rem;
      i {
        display: inline-block;
        width: 0.35rem;
        height: 0.35rem;
        background-image: url("../../assets/back/serach.png");
        background-size: 80%;
        background-repeat: no-repeat;
        background-position: 100% 100%;
        margin-right: 0.05rem;
      }

      span {
        color: #d93838;
        margin-right: 0.2rem;
      }

      a {
        font-weight: 400;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .yijian {
      div:first-of-type {
        display: flex;
        height: 0.35rem;
        align-items: center;

        >div {
          height: 0.05rem;
          width: 0.05rem;
          border-radius: 50%;
          background: #2d65d2;
          margin-right: 0.2rem;
        }
      }

      textarea {
        position: relative;
        top: -0.35rem;
        left: 1.1rem;
        width: 80%;
      }

      .opinion {
        // width: 60%;
        border: 1px solid #ccc;
        padding: 0.1rem;
        margin: 0.15rem 0;
      }
    }

    .sub {
      width: 100%;
      display: flex;
      justify-content: center;

      div {
        border-radius: 0.1rem;
      }
    }
  }
}

.block {
  .el-card__body {
    .head {
      display: flex;
      align-items: center;
      margin-bottom: 0.2rem;

      img {
        width: 0.4rem;
      }

      h4 {
        margin: 0 0.1rem;
      }

      div {
        margin-left: 0.2rem;
        font-size: 0.14rem;

        span {
          margin-right: 0.2rem;
        }
      }
    }

    .content {
      div {
        margin-bottom: 0.2rem;
      }

      div:last-of-type {
        margin-bottom: 0;
      }

      .score {
        span {
          margin-right: 0.3rem;
        }
      }

      .yj {
        display: flex;

        span {
          width: 8%;
        }

        div {
          width: 90%;
          // text-indent: 2em;
        }
      }
    }
  }
}

.Popup {
  width: 100%;
  position: absolute;
  top: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;

  .none {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .a_forms {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 7rem;
    //height: 6rem;
    background: white;
    font-size: 0.16rem;

    .f-top {
      height: 0.3rem;
      width: 100%;
      text-align: center;
      line-height: 0.5rem;
      position: relative;

      // border-bottom: 1px #cfcfcf solid;
      .el-icon-close {
        width: 0.5rem;
        height: 0.5rem;
        position: absolute;
        right: 0.1rem;
        top: 0.1rem;
        cursor: pointer;
      }

      div {
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 0;
        height: 0.5rem;
        width: 0.5rem;
        background: url("../../assets/back/x.png") center center no-repeat;
      }
    }

    .f-info {
      padding: 0.2rem 0.68rem 0;

      .p-info {
        >.p-input {
          align-items: center;
        }

        >.upimg {
          align-items: center;
          justify-content: space-between;
        }

        >div {
          margin: 0.2rem 0;
          display: flex;

          >.p-time {
            position: relative;
            flex: 1;
            margin: 0 0.2rem;

            >input {
              width: 100%;
              padding: 0.05rem;
              height: 0.3rem;
              border: 1px #cccccc solid;
            }

            .p-select {
              width: 100%;
              top: 0;
              left: 0;
              opacity: 0;
              position: absolute;
            }

            .icon {
              position: absolute;
              top: 0;
              right: 0;
              height: 0.3rem;
              width: 0.3rem;
              background: url("../../assets/back/time.png") center center no-repeat;
            }
          }

          >input,
          select {
            flex: 1;
            padding: 0.05rem;
            margin: 0 0.2rem;
            height: 0.4rem;
            border: 1px #cccccc solid;
          }

          >textarea {
            flex: 1;
            padding: 0.05rem;
            margin: 0 0.2rem;
            border: 1px #cccccc solid;
          }

          i {
            font-style: normal;
            color: #ff0d0d;
          }
        }
      }

      .f-bottom {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0.5rem 0;
      }
    }
  }
}
</style>